import { Box, Grid2 as Grid, InputAdornment } from "@mui/material";
import { ModalForm, PaymentRecord } from "../../../types";
import { TextField } from "../../common";
import { useValidateForm } from "../../../hooks";
import { refundAmountSchema } from "../../../validations";

type FormData = Pick<
  PaymentRecord,
  "id" | "orgId" | "accountId" | "invoiceNumber"
> & { refundAmount: number };

type RefundFormProps = ModalForm<PaymentRecord, FormData>;

export const RefundForm = ({
  id,
  defaultValues,
  handleEdit,
}: RefundFormProps) => {
  const maxRefundAllowed = Number(
    (
      (defaultValues?.amount ?? 0) - (defaultValues?.refundedAmount ?? 0)
    ).toFixed(2),
  );

  const { register, handleSubmit, errors } = useValidateForm(
    refundAmountSchema
      .refine((data) => data.refundAmount <= maxRefundAllowed, {
        message: `Refund amount cannot exceed ${maxRefundAllowed}`,
        path: ["refundAmount"],
      })
      .refine(
        (data) =>
          !data.refundAmount.toString().split(".")[1] ||
          data.refundAmount.toString().split(".")[1].length <= 2,
        {
          message: `Enter a valid amount with up to 2 decimal places`,
          path: ["refundAmount"],
        },
      ),
  );

  const handleEditWrapper = (data: { refundAmount: string | number }) => {
    handleEdit({
      id: defaultValues ? defaultValues.id : 0,
      orgId: defaultValues ? defaultValues.orgId : 0,
      accountId: defaultValues ? defaultValues.accountId : 0,
      invoiceNumber: defaultValues ? defaultValues.invoiceNumber : "",
      refundAmount: Number(data.refundAmount),
    });
  };

  return (
    <Box
      onSubmit={handleSubmit(handleEditWrapper)}
      component={"form"}
      id={id}
      noValidate
      sx={{
        height: "100%",
      }}
    >
      <Grid
        container
        size={12}
        direction={"column"}
        gap={3}
        sx={{
          borderRadius: "10px",
          p: 3,
          mb: 2,
          width: "100%",
        }}
      >
        <Grid size={12}>
          <TextField
            label="Refund Amount"
            name="refundAmount"
            type="number"
            valueAsNumber={true}
            required
            register={register}
            error={errors["refundAmount"]}
            defaultValue={maxRefundAllowed}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
